import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/../.sourceflow/blog_tags.json";

export const useBlogTags = () => {
  const collection = useSourceFlowCollection(data);

  return collection;
};

export default useBlogTags;
